export const COOKIE_CART = '_CART';
